$(function () {
    if ($('input[type=radio][name=hasDistrictDCPolicy]:checked').val() === 'true') {
        $('#districtDCPolicyDetailsInput').css('display', 'block');
    }

    if ($('#referrer').val()) {
        setReferrerDetailsInput($('#referrer').val());
    }

    $('input[type=radio][name=hasDistrictDCPolicy]').change(function () {
        if (this.value === 'true') {
            $('#districtDCPolicyDetailsInput').css('display', 'block');
        } else if (this.value === 'false') {
            $('#districtDCPolicyDetailsInput').css('display', 'none');
        }
    });

    $('#referrer').change(function () {
        setReferrerDetailsInput(this.value);
    });

    $('.js-contact-form').on('submit', function () {
        loader.showPageLoaderAndShield();
    });

    function setReferrerDetailsInput(value) {
        switch (value) {
        case 'Another district':
            $('#referrerDetailsLabel').text('Which district?');
            $('#referrerDetailsInput').css('display', 'block');
            $('#teacherReferrerDetailsInput').css('display', 'none');
            break;
        case 'A conference':
            $('#referrerDetailsLabel').text('Which conference?');
            $('#referrerDetailsInput').css('display', 'block');
            $('#teacherReferrerDetailsInput').css('display', 'none');
            break;
        case 'An Education Association':
            $('#referrerDetailsLabel').text('Which education association?');
            $('#referrerDetailsInput').css('display', 'block');
            $('#teacherReferrerDetailsInput').css('display', 'none');
            break;
        case 'A teacher in my district': // uses different divs because answer is yes/no radio buttons instead of input
            $('#teacherReferrerDetailsLabel').text('Is the teacher part of the DonorsChoose teacher ambassador program?');
            $('#teacherReferrerDetailsInput').css('display', 'block');
            $('#referrerDetailsInput').css('display', 'none');
            break;
        case 'Other':
            $('#referrerDetailsLabel').text('Please elaborate');
            $('#referrerDetailsInput').css('display', 'block');
            $('#teacherReferrerDetailsInput').css('display', 'none');
            break;
        default:
            $('#referrerDetailsInput').css('display', 'none');
            $('#teacherReferrerDetailsInput').css('display', 'none');
        }
    }
});

window.recaptchaDistrictPartnerCenterCallback = function () {
    /* global grecaptcha */ // Defined by google recaptcha API from districtpartnershipprogram.jsp
    if (typeof grecaptcha === 'undefined' || grecaptcha.getResponse().length !== 0) {
        $('#submitButton').removeClass('disabled');
    } else {
        $('#submitButton').addClass('disabled');
    }
};
